<template>
    <div :class="wrapperClass" class="input-group">
        <input :class="className"
               :type="isShowedPassword ? 'text' : 'password'"
               @input="handleInput"
               @keypress.enter="onEnterCallback"
               aria-describedby="validationTooltipUsernamePrepend"
               class="form-control"
               v-model="password"
        >
        <div @click="isShowedPassword=!isShowedPassword" class="input-group-append">
            <span class="input-group-text" id="validationTooltipUsernamePrepend">
                <i class="lh1 mdi mdi-eye-off" v-if="!isShowedPassword"></i>
                <i class="lh1 mdi mdi-eye" v-else></i>
            </span>
        </div>
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: "PasswordInput",
        props: [
            'value',
            'onEnter',
            'disabled',
            'placeholder',
            'className',
            'wrapperClass'
        ],
        data() {
            return {
                password: this.value,
                isShowedPassword: false
            }
        },
        methods: {
            handleInput() {
                this.$emit('input', this.password);
            },
            onEnterCallback() {
                if (typeof this.onEnter === "function")
                    return this.onEnter();
            }
        }
    }
</script>

<style scoped>
    .lh1 {
        line-height: 1;
    }
</style>